module.exports = "/_next/static/images/mf-9d0be1d48433b6e18933f34e5b0428d8.svg";